import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
export class IconCellRenderer implements ICellRenderer {
  params;

  eGui: HTMLElement;

  getGui() {
    return this.eGui;
  }

  init(params: ICellRendererParams<any>) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.style.display = 'flex';
    this.eGui.style.alignItems = 'center';
    this.eGui.style.justifyContent = 'center';
    this.eGui.style.height = '100%';
    this.eGui.style.width = '100%';
    this.eGui.style.position = 'relative';
    this.render();
  }

  refresh(params: ICellRendererParams<any>): boolean {
    this.params = params;
    this.eGui.innerHTML = '';
    this.render();
    return true;
  }

  private render(): void {
    const containerDiv = document.createElement('div');
    containerDiv.style.position = 'relative';

    if (this.params.iconName || this.params.iconSrc) {
      let icon;
      if (this.params.iconSrc) {
        icon = document.createElement('img');
        icon.setAttribute('src', this.params.iconSrc);
        icon.style.height = this.params.iconHeight || '14px';
        icon.style.width = 'auto';

      } else {
        if (this.params.enabled) {

        }
        icon = document.createElement('rapid-icon');
        icon.setAttribute('name', this.params.iconName);
        if (this.params.iconSize) {
          icon.setAttribute('size', this.params.iconSize);
        }
        if (this.params.iconColor) {
          icon.style.color = this.params.iconColor;
        }
        if (this.params.variant) {
          icon.setAttribute('variant', this.params.variant);
        }
      }

      if (this.params.enabled) {
        icon.style.cursor = 'pointer';
      } else {
        icon.style.cursor = 'not-allowed';
      }
      if (this.params.clickHandler && this.params.enabled) {
        icon.addEventListener('click', (e) => {
          this.params.clickHandler(e, this.params.data);
        });
      }

      if (this.params.showHover) {
        icon.style.padding = '5px';
        icon.style.lineHeight = '1';
        icon.style.borderRadius = '5px';

        icon.addEventListener('mouseover', () => {
          icon.style.backgroundColor = 'var(--neutral-stroke-hover)';
        });

        icon.addEventListener('mouseout', () => {
          icon.style.backgroundColor = 'unset';
        });
      }
      icon.style.borderRadius = '5px';
      containerDiv.append(icon);
    }

    if (this.params.secondaryIcon) {
      const secondaryIcon = document.createElement('rapid-icon');
      secondaryIcon.setAttribute('name', this.params.secondaryIcon);
      secondaryIcon.setAttribute('size', 'xs');
      secondaryIcon.style.color = this.params.secondaryIconColor;
      secondaryIcon.style.position = 'absolute';
      secondaryIcon.style.bottom = '0';
      secondaryIcon.style.right = '0';
      secondaryIcon.style.zIndex = '2';
      secondaryIcon.style.transform = 'translate(25%, -50%)';
      secondaryIcon.style.lineHeight = '1';
      containerDiv.append(secondaryIcon);
    }

    this.eGui.append(containerDiv);
  }
}
